import { Box } from '@mui/material'
import React from 'react'

const HandleRecoverEmail = () => {
  return (
    <Box>HandleRecoverEmail</Box>
  )
}

export default HandleRecoverEmail